export const environment = {
    production: false,
    bullhornWebUrl: 'https://testbatweb.bullhornsys.com/',
    bullhornApiUrl: 'https://testbullhornapi.bullhornsys.com/api',
    appUrl: 'https://dev-config.bullhornsys.com/'
};
